import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

// Demo data is opt-in during local development only; production must never silently fall back.
export const demoMode = import.meta.env.DEV && import.meta.env.VITE_DEMO_MODE === 'true';

export const supabase = !demoMode && url && anonKey
  ? createClient(url, anonKey, {
      auth: {
        persistSession: true,
        // Session-scoped (per browser tab) instead of localStorage across browser restarts.
        storage: typeof window !== 'undefined' ? window.sessionStorage : undefined,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;
